import React from 'react';
import Isvg from 'react-inlinesvg';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import css from './popup-menu.scss';
import DownloadIcon from '../participation-table/certificate-display/assets/download-icon.svg';

const PopUpMenu = ({ options, downloadReports, onClickHandler }) => {
    const closeDropdown = (index) => {
        onClickHandler();
        downloadReports(index);
    };
    const menu = options.map((item, index) => (
        <button
            key={item.label}
            id={index}
            aria-hidden={'true'}
            className={css['popup-menu-item']}
            onClick={() => closeDropdown(index)}
        >
            <span>
                <Isvg
                    className={css.icon}
                    src={DownloadIcon}
                    cacheGetRequests
                />
            </span>
            {item.label}
        </button>
    ));

    return <div className={css['popup-menu']}>{menu}</div>;
};

PopUpMenu.propTypes = {
    options: PropTypes.array,
    downloadReports: PropTypes.func,
    onClickHandler: PropTypes.func
};

export default styleable(css)(PopUpMenu);



// WEBPACK FOOTER //
// ./components/popup-menu/popup-menu.js